import Axios from 'axios'

import { parseAuthenticationHeader } from 'helpers/Functions'

const homepal_mdm_api =
  process.env.REACT_APP_HOMEPAL_MDM_API_DEV || 'http://localhost:3990/'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? homepal_mdm_api
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/connections/auth-param-values`

export type TAuthParamValuesBody = {
  data: Record<string, unknown>
}

export async function put(body: TAuthParamValuesBody, params = '') {
  const url = `${URL}${params}`

  return Axios.put(url, body, parseAuthenticationHeader())
}

export async function validate(body: TAuthParamValuesBody) {
  const url = `${URL}/validate-source`

  return Axios.put(url, body, parseAuthenticationHeader())
}

export async function validateDatabase(body: TAuthParamValuesBody) {
  const url = `${URL}/validate-database`

  return Axios.put(url, body, parseAuthenticationHeader())
}

export async function validateSFTP(body: TAuthParamValuesBody) {
  const url = `${URL}/validate-sftp`

  return Axios.put(url, body, parseAuthenticationHeader())
}
